import { useEffect, useRef } from "react"
import { GoogleOutlined } from "@ant-design/icons"
import { Button, Col, Layout, Row } from "antd"
import { message } from "../lib/messageHolder"
import { useDispatch, useSelector } from "react-redux"
import { oAuthSucceeded } from "../actions/user"
import "../less/Login.less"
import logo from "../resources/img/investant.svg"
import { Slant } from "./Slant"

const Login = () => {
  const dispatch = useDispatch()
  const error = useSelector((state) => state.login.error)
  const gSignInContainer = useRef(null)

  const onLoginSuccess = (res) => dispatch(oAuthSucceeded(res))

  useEffect(() => {
    const params = {
      client_id: "493693770533-oe99kut9cufqoaqi8sg88i07mfmtum4d.apps.googleusercontent.com",
      callback: onLoginSuccess,
      // FedCM migration: updated configuration
      auto_select: false, // Don't automatically select the first account
      cancel_on_tap_outside: false,
      itp_support: false, // Disable Identity Token Provider support
      use_fedcm_for_prompt: true // Enable FedCM for the prompt
    }

    window.google.accounts.id.initialize(params)

    // Render the Google Sign-In button (FedCM migration)
    window.google.accounts.id.renderButton(gSignInContainer.current, {
      theme: "filled_blue",
      text: "signin_with",
      shape: "pill",
      logo_alignment: "left",
      width: 250,
      size: "large",
      locale: "en_US",
    })

    // Prompt one tap sign in with FedCM compatible approach
    window.google.accounts.id.prompt()
  }, [dispatch]); // Add dispatch to dependencies

  useEffect(() => {
    if (error) {
      message.error(error.message || "UNKNOWN_ERROR")
    }
  }, [error]);

  return (
    <Layout>
      <Layout style={{ flexGrow: "1", minHeight: "100vh" }}>
        <Layout style={{ padding: "0 30px 30px 30px", position: "relative" }}>
          <Slant height="300px" />

          <Row justify="center" align="middle">
            <Col style={{ textAlign: "center" }}>
              <img src={logo} alt="Investant" className="login-logo" />
              <br />

              <div id="g-signin-container" ref={gSignInContainer} />
            </Col>
          </Row>
        </Layout>
      </Layout>
    </Layout>
  )
}

export default Login
